import React, { Component } from 'react';

export const NoMatch = () => (

  <div>
  <h2>Wrong page</h2>
    <p>This is some content of the wrong page </p>		
  </div>
)
